export default __webpack_public_path__ + "static/media/HERO.292f08c0.jpg";